import ResourceApi from '../ResourceApi';

const SicknessResource = {
  index: async (params = {}) => (await ResourceApi.get('/resource/sickness', params)).data,
  get: async (id, params = {}) => (await ResourceApi.get(`/resource/sickness/${id}`, params)).data,

  dayPut: async (id, params = {}) => (await ResourceApi.put(`/resource/sickness/day/${id}`, params)).data,
  dayDelete: async (id, params = {}) => (await ResourceApi.destroy(`/resource/sickness/day/${id}`, params)).data,

  types: async () => (await ResourceApi.get('/resource/sickness/types')).data,
  payTypes: async () => (await ResourceApi.get('/resource/sickness/pay-types')).data,
};

export default SicknessResource;
